import { Injectable } from '@angular/core';
import {ViewService} from "../../services/crud/interfaces/view-service.interface";
import {CardActivity, CardActivityInfoModel} from "../../dto/cardInfoModelBase";
import { Observable } from 'rxjs';
import { DataListModel } from '../../models/data-list-model';
import {HttpClient, HttpParams} from "@angular/common/http";
import {BankTransferLoad} from "../../dto/bankTransferLoad";
import {toISODateString, toServerDateString} from "../../providers/app-date-adapter";
import {DateTableFilter} from "../../table-datasouces/date-table-filter";
import {filter} from "rxjs/operators";

@Injectable({
  providedIn: "root"
})
export class CardActivitiesService implements ViewService<CardActivity> {

  readonly apiPath = 'card-activities/';

  constructor(
    private http: HttpClient,

  ) {

  }

  getMany(
    pageIndex: number,
    pageSize: number,
    sortField: string,
    sortDirection: string,
    filterString: string,
    dateFilterCols: string[],
    startFilterDate: Date,
    endFilterDate: Date,
    someAdditionalData: string,
    productsFilter?: string[],

    additionalField1?: string,
    additionalField2?: string,
    additionalValue1?: string,
    additionalValue2?: string,

    numberFrom?: number,
    numberTo?: number,


  ): Observable<DataListModel<CardActivity>> {

    let params = new HttpParams()
      .set('page', pageIndex.toString())
      .set('pageSize', pageSize.toString())
      .set('filterString', filterString)

      .set('startFilterDate', toServerDateString(startFilterDate))
      .set('endFilterDate', toServerDateString(endFilterDate))

      .set('sortField', sortField)
      .set('sortDirection', sortDirection )
      .set('someAdditionalData', someAdditionalData )

      .set('additionalField1', additionalField1)
      .set('additionalField2', additionalField2)
      .set('additionalValue1', additionalValue1)
      .set('additionalValue2', additionalValue2)

      .set('numberFrom', numberFrom)
      .set('numberTo', numberTo)
    ;

    if (dateFilterCols instanceof Array) {
      dateFilterCols.forEach(element => {
        params = params.append('dateFilterCols', element);
      });
    }

    if (productsFilter instanceof Array) {
      productsFilter.forEach(element => {
        params = params.append('productsFilter', element);
      });
    }

    return this.http.get(this.apiPath, { params }) as Observable<DataListModel<CardActivity>>;


    }
}
